import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Domain } from '../../graphql/generated/graphql.ts';

export interface LargeDomainProps {
  domain: Partial<Domain>;
}

export const LargeDomain: FC<LargeDomainProps> = ({ domain }) => {
  if (!domain) {
    return null;
  }
  return (
    <Stack
      display="flex"
      justifyContent="center"
      alignItems="center" // Center content horizontally
      width="100%"
      direction="column"
      textAlign="center"
      spacing={1}
    >
      {domain.iconUrl && (
        <Box
          component="img"
          src={domain.iconUrl}
          alt={domain.title}
          sx={{
            maxWidth: '100%', // Ensure the image never exceeds the container's width
            maxHeight: '150px', // Maximum height
            height: 'auto', // Maintain the aspect ratio
            width: 'auto', // Maintain the aspect ratio
            mb: 3
          }}
        />
      )}
      <Typography variant="h4" sx={{ color: domain.color }}>
        {domain.title}
      </Typography>
      <Typography variant="h6">{domain.subTitle}</Typography>
    </Stack>
  );
};
